import he from "he";

/**
 * Extract the filename from a Content-Disposition header value. Returns null
 * when the header is absent or doesn't include a filename parameter. Handles
 * both quoted (`filename="foo.xlsx"`) and unquoted (`filename=foo.xlsx`)
 * forms.
 *
 * The header is HTML-decoded before parsing: the API runs some filenames
 * through `string.encodeSymbols` (see FilesController), and an entity
 * reference such as `&#x26;` contains a `;`, which would otherwise truncate
 * the filename at the first encoded symbol. Decoding is a no-op for the
 * endpoints that send a plain ASCII filename.
 */
export function filenameFromContentDisposition(header) {
	if (typeof header !== "string") return null;
	const match = he.decode(header).match(/filename="?([^";]+)"?/);
	return match ? match[1] : null;
}
